module.exports = __webpack_public_path__ + "media/components/Cards/images/metal-gold-card-3597488df28e5034cb5fa390aa5d3183.png";